import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';

import { ActiveFilterContentComponent } from '@connect-services/client/components/active-filter-content/active-filter-content.component';
import { ActiveFilterItemComponent } from '@connect-services/client/components/active-filter-content/active-filter-item/active-filter-item.component';
import { ButtonType, IconPosition } from '@connect-services/src/lib/components/button/button.component';
import { MapFilter } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ActiveFilterItemComponent, RessourcesModule],
    selector: 'app-active-filter-dropdown',
    styleUrl: './active-filter-dropdown.component.scss',
    templateUrl: './active-filter-dropdown.component.html',
})
export class ActiveFilterDropdownComponent {
    public readonly activeFiltersInDropdown: InputSignal<MapFilter[]> = input.required<MapFilter[]>();
    public readonly currentWidth: InputSignal<number> = input.required<number>();

    protected readonly ActiveFilterContentComponent = ActiveFilterContentComponent;
    protected readonly ButtonType = ButtonType;
    protected readonly dropdownWidth: Signal<number> = computed(() => {
        return this.currentWidth() > ActiveFilterContentComponent.DROPDOWN_WIDTH_REM_WITH_MARGIN ? 8.5 : 2;
    });
    protected readonly IconPosition = IconPosition;
}
